import { DEFAULT_ALL_ITEM } from "../types/common";

export interface Prompt {
    label: string;
    value: string;
}

export enum PromptVariable {
    BRAND = "{brand}",
    BROWSE_NODE = "{browseNode}",
}

export const getInsightsExamplePrompts = ({
    brand,
    browseNode,
    isAccountAgnostic = false,
}: {
    brand?: string;
    browseNode?: string;
    isAccountAgnostic?: boolean;
}): Prompt[] => {
    const prompts = [
        {
            label: "Peer Benchmarking",
            value: `How does ${PromptVariable.BRAND}'s overall performance in ${PromptVariable.BROWSE_NODE} on Amazon compare to peers, and what are the implications for advertising effectiveness, sales growth, and customer acquisition?`,
        },
        {
            label: "Audience Insights",
            value: `How can ${PromptVariable.BRAND} in ${PromptVariable.BROWSE_NODE} optimize campaigns and build customer loyalty to maximize lifetime value?`,
        },
        {
            label: "Audience Funnel",
            value: `What are the audience sizes and conversion rates across funnel stages for ${PromptVariable.BRAND} in ${PromptVariable.BROWSE_NODE} on Amazon?`,
        },
        {
            label: "Share of Voice",
            value: `How can ${PromptVariable.BRAND} in ${PromptVariable.BROWSE_NODE} strengthen its brand presence and drive consideration through advertising and competitive strategy?`,
        },
        {
            label: "Branded Search Trends",
            value: `When are peak awareness and consideration periods for ${PromptVariable.BRAND} in ${PromptVariable.BROWSE_NODE}, and how can it capitalize?`,
        },
        {
            label: "ASIN Targeting Strategy",
            value: `How can I target customers based on their ASIN viewing patterns and remarketing opportunities?`,
        },
        {
            label: "Campaign Overlap Analysis",
            value: `How does customer conversion change when they see multiple different ad campaigns?`,
        },
        {
            label: "Event Marketing Strategy",
            value: `What are the advertising opportunities before, during, and after seasonal events?`,
        },
        {
            label: "Customer Journey Analysis",
            value: `Which ad touchpoints do customers encounter before converting?`,
        },
        {
            label: "Customer Value Analysis",
            value: `What is the first-year value of new versus existing customers compared to category peers?`,
        },
    ];

    return isAccountAgnostic
        ? prompts.filter(
              (p) =>
                  !p.value.includes(PromptVariable.BRAND) &&
                  !p.value.includes(PromptVariable.BROWSE_NODE),
          )
        : prompts.map((p) => ({
              ...p,
              value: replacePromptWithValues(p.value, brand, browseNode),
          }));
};

export const replacePromptWithValues = (
    prompt: string,
    brand: string | undefined,
    browseNode: string | undefined,
): string => {
    let promptCopy = `${prompt}`;
    const replaceBrand = brand && brand !== DEFAULT_ALL_ITEM.label;
    const replaceBrowseNode =
        browseNode && browseNode !== DEFAULT_ALL_ITEM.label;
    if (replaceBrand) {
        promptCopy = promptCopy.replace(PromptVariable.BRAND, brand);
    }

    if (replaceBrowseNode) {
        promptCopy = promptCopy.replace(PromptVariable.BROWSE_NODE, browseNode);
    }
    return promptCopy;
};
